/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IIframeViewProps } from '@msdyn365-commerce-modules/iframe';

/**
 *
 * IFrameView component.
 * @extends {React.PureComponent<IIframeViewProps>}
 */
export class IFrameView extends React.PureComponent<IIframeViewProps> {
    public render(): JSX.Element | null {
        const { Heading, IframeContainer, IFrame } = this.props;

        // Since we've removed the cookie consent warning we don't ever have to show 'alert' since it's only ever used for that

        return (
            <Module {...IframeContainer}>
                {Heading}
                {IFrame}
            </Module>
        );
    }
}
export default IFrameView;
